// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/opt/buildhome/repo/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-templates-index-js": () => import("/opt/buildhome/repo/src/templates/index.js" /* webpackChunkName: "component---src-templates-index-js" */),
  "component---src-templates-blog-post-js": () => import("/opt/buildhome/repo/src/templates/blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/buildhome/repo/.cache/data.json")

